/**
 * Calculate count for a specific period (last week or previous day)
 */
export function calculatePeriodCount(periodProducts, menu, curr) {
  return periodProducts
    .filter(
      (x) =>
        // eslint-disable-next-line operator-linebreak
        x.entryMenuId === menu.nodeId &&
        // eslint-disable-next-line operator-linebreak
        x.entryDietId === curr.entryDietId &&
        x.productId === curr.productId,
    )
    .reduce((a, c) => a + c.count, 0);
}

/**
 * Process ingredients for an order
 */
export function processIngredients(ingredients, count, delivered) {
  return ingredients.map((x) => ({
    ...x,
    weight: x.weight * count,
    count: x.count * count,
    deliveredWeight: x.weight * delivered,
    deliveredCount: x.count * delivered,
  }));
}

/**
 * Merge ingredients into an accumulator object
 */
export function mergeIngredients(ingredientsArray, ingredientDetails) {
  /* eslint-disable no-param-reassign */
  return ingredientsArray.reduce((a, c) => {
    if (!a[c.id]) {
      a[c.id] = {
        ...c,
        details: ingredientDetails.find((y) => y.id === c.id) || {},
      };
    } else {
      a[c.id].count += c.count;
      a[c.id].weight += c.weight;
      a[c.id].deliveredWeight += c.deliveredWeight;
      a[c.id].deliveredCount += c.deliveredCount;
    }
    return a;
  }, {});
  /* eslint-enable no-param-reassign */
}

/**
 * Merge existing ingredient with new ingredient data
 */
export function mergeExistingIngredient(existingIngredient, newIngredient) {
  /* eslint-disable no-param-reassign */
  existingIngredient.count += newIngredient.count;
  existingIngredient.weight += newIngredient.weight;
  existingIngredient.deliveredWeight += newIngredient.deliveredWeight;
  existingIngredient.deliveredCount += newIngredient.deliveredCount;
  /* eslint-enable no-param-reassign */
}

/**
 * Create a new product entry
 */
export function createProductEntry(productId, productName, order, mealName) {
  return {
    productId,
    productName,
    order,
    mealName: mealName || '',
    subProducts: [],
  };
}

/**
 * Create a new subProduct entry
 */
export function createSubProduct(
  entryDietId,
  dietName,
  count,
  delivered,
  lastWeekCount,
  previousDayCount,
  ingredients,
) {
  return {
    entryDietId,
    dietName,
    count,
    delivered,
    lastWeekCount,
    previousDayCount,
    ingredients,
  };
}

/**
 * Calculate aggregated counts for a product from its subProducts
 */
export function aggregateProductCounts(subProducts) {
  return {
    count: subProducts.reduce((sum, sub) => sum + sub.count, 0),
    delivered: subProducts.reduce((sum, sub) => sum + sub.delivered, 0),
    lastWeekCount: subProducts.reduce((sum, sub) => sum + sub.lastWeekCount, 0),
    previousDayCount: subProducts.reduce((sum, sub) => sum + sub.previousDayCount, 0),
  };
}
